var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('strong',[_vm._v(_vm._s(_vm.destination))]),_vm._v("\n\t"+_vm._s(_vm.description)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }